import Index from "views/Index.js";
import Profile from "views/examples/Profile.js";
import Register from "views/examples/Register.js";
import Login from "views/examples/Login.js";
import Tables from "views/examples/Usuarios";
import Icons from "views/examples/Icons.js";
import Talleres from "views/examples/Talleres";
import Consultas from "views/examples/consultas";
import Reportes from "views/examples/Reportes";
import ListaChequeo from "views/examples/listasChequeo";
import Equipos from "views/examples/Equipos";
import Ordenes from "views/examples/Ordenes";
import InfoTipoOrdenServicio from "views/examples/InfoTipoOrdenServicio";
import Marcas from "views/examples/Marcas";
import OrdenesHistorico from "views/examples/OrdenesHistorico";
import ConsultaCargaMasiva from "views/examples/CargaMasiva";
import ReporteTaller from "views/examples/ReporteTaller";
import ConsultaTaller from "views/examples/ConsultaTaller";
import ConsultaHistoricoSicom from "views/examples/RegistrosSicom";
import ReporteDistribuidor from "views/examples/ReporteDistribuidor";

var routes = [
  {
    path: "/perfil",
    name: "Perfil",
    icon: "ni ni-settings-gear-65 text-blue",
    component: <Profile />,
    layout: "/admin",
  },
  {
    name: " Gestión",
    icon: "ni ni-settings-gear-65 text-blue",
    routes: [
      {
        path: "/Ordenes",
        name: "Órdenes",
        icon: "ni ni-single-02 text-blue",
        component: <Ordenes />,
        layout: "/admin",
      },

      {
        path: "/tables",
        name: "Usuarios",
        icon: "ni ni-single-02 text-blue",
        component: <Tables />,
        layout: "/admin",
      },
      {
        path: "/Equipos",
        name: "Equipos",
        icon: "fa fa-desktop text-blue",
        component: <Equipos />,
        layout: "/admin",
      },

      {
        path: "/talleres",
        name: "Talleres",
        icon: "fa fa-home text-blue",
        component: <Talleres />,
        layout: "/admin",
      },

      {
        path: "/TipoOrdenes",
        name: "Tipo Órdenes",
        icon: "fa fa-exchange text-blue",
        component: <InfoTipoOrdenServicio />,
        layout: "/admin",
      },
      {
        path: "/OrdenesHisorico",
        name: "Órdenes Historico",
        icon: "ni ni-single-02 text-blue",
        component: <OrdenesHistorico />,
        layout: "/admin",
      },
    ],
  },
  {
    name: " Mantenimiento",
    icon: "ni ni-bullet-list-67 text-blue",
    routes: [
      {
        path: "/listas",
        name: "Lista de Chequeo",
        icon: "ni ni-bullet-list-67 text-blue",
        component: <ListaChequeo />,
        layout: "/admin",
      },
      {
        path: "/marcas",
        name: "Marcas",
        icon: "fa fa-tags text-blue",
        component: <Marcas />,
        layout: "/admin",
      },
      {
        path: "/ReporteTaller",
        name: "Reporte del taller",
        icon: "fa fa-file-alt text-blue",
        component: <ReporteTaller />,
        layout: "/admin",
        hidden: true,
      },
    ],
  },
  {
    name: " Consultas",
    icon: "ni ni-chat-round text-blue",
    routes: [
      {
        path: "/consultas",
        name: "Consultas Vehiculos",
        icon: "fa fa-question-circle text-blue",

        component: <Consultas />,
        layout: "/admin",
      },
      {
        path: "/consultasTaller",
        name: "Consultas Talleres",
        icon: "fa fa-home text-blue",

        component: <ConsultaTaller />,
        layout: "/admin",
      },
      {
        path: "/reportes",
        name: "Reporte Facturación",
        icon: "fa fa-file-alt text-blue",
        component: <Reportes />,
        layout: "/admin",
      },
      {
        path: "/SICOM",
        name: "SICOM",
        icon: "fa fa-file-alt text-blue",
        component: <ConsultaCargaMasiva />,
        layout: "/admin",
      },
      {
        path: "/ConsultaHistoricoSicom",
        name: "ConsultaHistoricoSicom",
        icon: "fa fa-desktop text-blue",
        component: <ConsultaHistoricoSicom />,
        layout: "/admin",
      },

      {
        path: "/distribuidor",
        name: "Reporte Distribuidor",
        icon: "fa fa-question-circle text-blue",
        component: <ReporteDistribuidor />,
        layout: "/admin",
      },
    ],
  },

  {
    name: " Autenticación",
    hidden: true, // Esta propiedad se utiliza para ocultar las rutas de autenticación
    routes: [
      {
        path: "/login",
        icon: "fa fa-sign-out-alt text-blue",
        name: "",
        component: <Login />,
        layout: "/auth",
      },
    ],
  },
];

export default routes;
